import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";
import { useIntl } from "react-intl";
import { TextInput, Button } from "@mantine/core";
import { toast } from "react-toastify";
//import KeysImage from "../assets/images/signinup.png";
//import KeysImage from "../assets/images/signinup_modern.png";
//import KeysImage from "../assets/images/signinup_oldstyle.png";
import { sanitizeInput, validateEmail } from "../utils/helpers";

export default function ForgotPassword() {
  const intl = useIntl();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({
    email: "",
  });
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const onChange = (e: any) => {
    setEmail(e.target.value.trim());
  };

  const onBlur = (e: any) => {
    let error = "";
    const { id } = e.target;
    var sanitizedValue = sanitizeInput(email);
    if (!validateEmail(email)) {
      error = "Please enter a valid email address.";
    } else if (sanitizedValue !== email)
      error = "Please remove all special symbols from the email address.";
    else error = "";

    setSubmitEnabled(error === "");
    setErrors((prevState) => ({
      ...prevState,
      [id]: error,
    }));
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, sanitizeInput(email));
      toast.success("Email was sent");
    } catch (error) {
      toast.error("Could not send email for reset password");
    }
  };

  return (
    <section>
      <h1 className="forgot-password-heading">
        {intl.formatMessage({ id: "forgotpassword.forgotPassword" })}
      </h1>
      <div className="forgot-password-container">
        <div className="forgot-password-form">
          <form onSubmit={onSubmit}>
            <TextInput
              type="email"
              id="email"
              value={email}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={intl.formatMessage({
                id: "forgotpassword.emailAddress",
              })}
              className="forgot-password-input"
              maxLength={100}
              error={errors.email}
            />
            <Button
              disabled={!submitEnabled}
              fullWidth
              className="forgot-password-submit"
              type="submit"
            >
              {intl.formatMessage({ id: "forgotpassword.resetPassword" })}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
}
